import ApiService from "@/api.service";

export const CLEAR_CACHE = "/admin/delete-all-redis";



const state = {

};

const getters = {

};

const actions = {
    [CLEAR_CACHE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${CLEAR_CACHE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {

};

export default {
    state,
    actions,
    mutations,
    getters
};